import type {
  CampaignTemplateCustomStyle,
  ClubCampaignPrefectureGroup,
} from "@components/CampaignTemplate";
import CampaignTemplate from "@components/CampaignTemplate";
import { CommonHead } from "@components/CommonHead";
import CommonLayout from "@components/CommonLayout";
import { isTypeProps, queryForSSP } from "@libs/apolloClient";
import { paths } from "@libs/paths";
import { Fctokyo202203_RawShopsDocument as RawShopsDocument } from "./__generated__/queries";
import styles from "./index.module.css";
import type { Fctokyo202203_RawShopsQueryResult as RawShopsQueryResult } from "./__generated__/queries";
import type { ApolloError } from "@apollo/client";
import type { GetServerSideProps, NextPage } from "next";

const isProduction = process.env.DEPLOY_ENV === "production";
const PREFECTURES: Array<ClubCampaignPrefectureGroup> = [
  {
    prefecture: "東京",
    shopUuids: isProduction
      ? [
          "Mz3mi2fG9nT2",
          "Utk6O7g2l0c2",
          "kyEjqxabIpMf",
          "TcfSDsXxaCSU",
          "OW5pmZO7jmL2",
          "8w5FJIgSU2pi",
          "8fjWJn7yXB46",
        ]
      : [
          "UuidUuidUuid",
          "UuidUuidUuid",
          "UuidUuidUuid",
          "UuidUuidUuid",
          "UuidUuidUuid",
          "UuidUuidUuid",
          "UuidUuidUuid",
        ],
  },
];

type FcTokyo202203PageProps = {
  data?: RawShopsQueryResult["data"];
  prefectures?: Array<ClubCampaignPrefectureGroup>;
  error?: ApolloError;
};

const FcTokyo202203: NextPage<FcTokyo202203PageProps> = ({
  data,
  prefectures,
}) => {
  return (
    <CommonLayout hasFooter noModal>
      <CommonHead
        title={"FC東京をお店で応援！FC東京を観戦できるスポーツバー"}
        description={
          "明治安田J1リーグのFC東京戦を応援できる渋谷、新宿、高田馬場、吉祥寺、秋葉原、明大前、調布などのDAZN公式契約スポーツバーをご紹介。応援ドリンクも販売中。スポーツバー探し、予約はFanstaで。"
        }
        ogUrl={paths.campaignFcTokyo202203}
        ogImage={`${process.env.APP_HOST}/img/campaign/fctokyo-202203/ogp.png`}
        canonicalUrl={paths.campaignFcTokyo202203}
      />
      <CampaignTemplate
        teamName="FC東京"
        slug="fctokyo-202203"
        leagueName="明治安田J1リーグ"
        teamIds={[6]}
        colorText="青赤"
        prefectures={prefectures}
        shopData={data?.rawShops}
        customStyle={styles as CampaignTemplateCustomStyle}
        sportGenreSlug={"soccer"}
        teamSlug={"fctokyo"}
        specialEventAreaHidden
      />
    </CommonLayout>
  );
};

export const getServerSideProps: GetServerSideProps = async () => {
  // PREFECTURESに定義されたデータからUUIDを抽出する。
  const shopUuids = PREFECTURES.map((p) => p.shopUuids);
  const flattenShopUuids = ([] as Array<string>).concat(...shopUuids);

  // 該当する店舗を検索する。
  const pageProps = await queryForSSP({
    query: RawShopsDocument,
    variables: {
      uuids: flattenShopUuids,
    },
  });

  if (!isTypeProps(pageProps)) {
    return {
      props: {},
    };
  }

  return {
    props: {
      ...pageProps.props,
      prefectures: PREFECTURES,
    },
  };
};

export default FcTokyo202203;
